export default __webpack_public_path__ + "static/media/FiraSans-BoldItalic.636810c3.woff2";